module.exports = __webpack_public_path__ + "static/img/partner2.f62cf3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partner2.png
// module id = B3K8
// module chunks = 8